import { Divider } from 'antd';
import { DevelopersService, StyleListModel } from 'api';
import { LoadingSpinner } from 'components/loading-spinner/loading-spinner';
import Notification from 'components/notification/notification';
import ProductStyleList from 'components/productstylelist/product-style-list';
import { ROUTES } from 'helpers/constants';
import Typography from 'helpers/fonts';
import { useSmallScreen } from 'helpers/isSmallScreen';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useAppState } from 'state/appstate/appstate';
import { useNotificationStore } from 'state/notificationstate/notificationstate';
import { useUiState } from '../state/ui-state/ui-state';

export interface StylesSelectionScreenProps {}

const StylesSelectionScreen: React.FunctionComponent<StylesSelectionScreenProps> = () => {
  const isSmallScreen = useSmallScreen();
  const { t } = useTranslation();
  const [styles, setStyles] = useState<Array<StyleListModel>>();

  const history = useHistory();
  const setStyleById = useAppState((state) => state.setStyleById);
  const notificationRef = React.useRef<HTMLDivElement>(null);
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const appState = useAppState((state) => ({
    setStyleById: state.setStyleById,
    product: state.styleProduct.product,
  }));
  const { setViewerFirstLoading } = useUiState()

  useEffect(() => {
    // load styles
    const load = async () => {
      try {
        const s = await DevelopersService.getStylesForProduct(
          appState.product!.id
        );
        setStyles(s);
      } catch (error) {
        setNotification(
          `error loading styles for product ${appState.product!.id}`,
          'error',
          'small'
        );
      }
    };

    if (appState.product?.id) {
      load();
    }
  }, [appState.product, appState.product?.id, setNotification]);


  return (
    <>
      <div
        style={{
          width: '100%',
          backgroundColor: Theme['@grey-lightest'],
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: '1 1 auto',
          justifyContent: 'space-between',
        }}
        ref={notificationRef}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: isSmallScreen ? '12px 16px' : '32px 16px',
          }}
        >
          <Typography styleid={isSmallScreen ? 4 : 1}>
            {t('stylesScreen.title')}
          </Typography>
          <Divider
            style={{
              width: '78px',
              minWidth: 0,
              borderTop: `4px solid ${Theme['@primary-color']}`,
              margin: isSmallScreen ? '16px 0px 16px' : '20px 0px 64px',
            }}
          />
          <Typography
            styleid={2}
            style={{ textAlign: 'center' }}
          >
            {appState.product?.title}
          </Typography>
          <Typography
            styleid={4}
            style={{
              textAlign: 'center',
              marginTop: 16,
              ...(isSmallScreen ? { marginBottom: 16 } : { fontSize: '22px', lineHeight: '22px' }),
            }}
          >
            {t('stylesScreen.description')}
          </Typography>
          {styles ? (
            <ProductStyleList
              items={styles}
              onSelectItem={async (id: string) => {
                try {
                  setViewerFirstLoading(true);
                  await setStyleById(id);
                  history.push(ROUTES.BUILD_SCREEN);
                } catch (error) {
                  setViewerFirstLoading(false)
                  setNotification(error.message, 'error', 'small');
                }
              }}
            />
          ) : (
            <span style={{ color: Theme['@primary-color'] }}>
              <LoadingSpinner />
            </span>
          )}
        </div>
      </div>
      <Notification parent={notificationRef} />
    </>
  );
};

export default StylesSelectionScreen;
